'use strict';

/**
 * @module currency/Currency
 * @memberof kernel
 * @description Currency object for handling currency format
 */
//define(function(require){

	var currencyCode,
		language,
		minorSymbol,
		majorPrefix,
		majorSuffix,
		minorPrefix,
		minorSuffix,
		decimalSeparator,
		thousandsSeparator,
		decimalPrecision,
		minorCurrencyLock,
		denomamount,
		chipSetCode,
		chipSet,
		minChip;

	var config;

	/**
	 * @function init
	 * @description Initialise Currency with currency data and denomination
	 * @param currencies {object} Currency config data from RGS
	 * @param denom {number} denomamount from client config
	 * @return undefined
	 */
	function init(currencies, denom){
		config = Object.freeze(currencies);

		var currencyConfig = config.CURRENCY;	
		var space = currencyConfig.MAJOR_SYMBOL_PADDING_SPACE === 'true' ? '\u00a0' : '';

		language = currencyConfig['@language'];
		currencyCode = currencyConfig['@currencyCode'];
		decimalPrecision = parseInt(currencyConfig.DECIMAL_PRECISION);
		decimalSeparator = decimalPrecision > 0 ? currencyConfig.DECIMAL_SEPARATOR : '';

		majorPrefix = currencyConfig.MAJOR_SYMBOL_ALIGNMENT === 'left' ? 
			currencyConfig.MAJOR_SYMBOL + (currencyConfig.MAJOR_SYMBOL_PADDING_SPACE === 'true' ? space : '') : '';
		majorSuffix = currencyConfig.MAJOR_SYMBOL_ALIGNMENT === 'right' ? 
			(currencyConfig.MAJOR_SYMBOL_PADDING_SPACE === 'true' ? space : '') + currencyConfig.MAJOR_SYMBOL : '';

		minorPrefix = currencyConfig.MINOR_SYMBOL_ALIGNMENT === 'left' ? 
			currencyConfig.MINOR_SYMBOL + (currencyConfig.MINOR_SYMBOL_PADDING_SPACE === 'true' ? space : '') : '';
		minorSuffix = currencyConfig.MINOR_SYMBOL_ALIGNMENT === 'right' ?
			(currencyConfig.MINOR_SYMBOL_PADDING_SPACE === 'true' ? space : '') + currencyConfig.MINOR_SYMBOL : '';

		minorCurrencyLock = currencyConfig.MINOR_CURRENCY_LOCK === "yes";

		thousandsSeparator = (currencyConfig.USE_THOUSANDS_SEPARATOR === 'yes' ? currencyConfig.THOUSANDS_SEPARATOR : '').replace('_','\u00a0');
		chipSetCode = currencyConfig.CHIP_SET_CODE;

		// rgs already filtered out non-necessary chipsets for client
		chipSet = config.CHIP_SET_DEFINITIONS.CHIP_SET.CHIP;
		// set the min chip
		minChip = chipSet[0] || 1;

		//replace _chipSet values with multiples of the smallest chip
		chipSet = chipSet.map(
			function(value){
				return Math.round(value / minChip);
			}
		);

		updateDenom(denom);
	}


	/**
	 * @function format
	 * @description Format stake values to currency by specific currency format config
	 * @param stakeUnits {number} Currency value in stake units (ie multiples of denom)
	 * @param useShort {boolean} whether or not to return a number without a separator and value after the decimal point.
	 * @param useMinorSymbol {boolean} whether or not to use the 'minor' symbol (eg 'p' for pence)
	 * @instance
	 * @return {string} The formatter currency by currency format config, contains currency sign, decimal separator etc.
	 */
	function format(stakeUnits, useShort, useMinorSymbol){
		if(!config){
			throw new Error("Currency: currency config is required");
		}

		var currency = toCurrency(stakeUnits),
		    prefix = majorPrefix, suffix = majorSuffix, separator = decimalSeparator;

		if(useMinorSymbol || minorCurrencyLock){
			currency = toMinorCurrency(currency);
			prefix = minorPrefix;
			suffix = minorSuffix;
			separator = '';
		}

		var currency = currency.split('.'),
		    pounds = (+currency[0]).toString(),
		    pence = currency[1] || '',
		    matches;

		if(thousandsSeparator){
			while(matches = pounds.match(/^(\d+)(\d\d\d)(.*)$/)){
				pounds = matches[1].concat(thousandsSeparator, matches[2], matches[3]);
			}
		}

		useShort = useShort && parseInt(pence) === 0;

		return prefix.concat(
			pounds,
			useShort ? '' : separator,
			useShort ? '' : pence,
			suffix
		);
	}

	/**
	 * @function toMinorCurrency
	 * @description Convert from major currecy to minor currency
	 * @instance
	 * @private
	 * @param currency {number}
	 * @return {string} the minor currency formatted into the proper units
	 */
	function toMinorCurrency(majorCurrency){
		var currencyChangeUnit = 1;
		for(var i = 0; i < decimalPrecision; i++){
			currencyChangeUnit *= 10;
		}
		return (majorCurrency * currencyChangeUnit).toFixed(0);
	}

	/**	
	 * @function formatFloat
	 * @description Takes the currency value and converts it out to the selected currency's format
	 * @param currency {number} - currency value
	 * @param useShort {boolean} - shorten notation for formatting currency
	 * @return {string} formatted currency string
	*/
	function formatFloat(currency, useShort){
		return format(toStakeUnits(currency), useShort);
	}

	/**
	 * @function formatShort
	 * @description Convert input stake units to currency and do formatting to the selected currency, the result will be truncates decimal places. 
	 * @instance
	 * @param stakeUnits {number} - stake values
	 * @return {string} The amount formatted in the selected currency's format
	 */
	function formatShort(stakeUnits){
		return format(stakeUnits, true);
	}

	/**
	 * @function formatLong
	 * @description Takes the stake units and converts it out into the selected currency's format.
	 * @instance
	 * @param stakeUnits {number} - stake values
	 * @return {string} The amount formatted in the selected currency's format
	 */
	function formatLong(stakeUnits){
		return format(stakeUnits, false);
	}

	/**
	 * @function toStakeUnits
	 * @description Takes currency value and conver to stake untis
	 * @param currency {number} - currency value
     * @return {float} - the stake units
	*/
	function toStakeUnits (currency){
		return currency / denomamount;
	}

	/**
	 * TBC looks we dont need provide format chips feature in platform ?
	 * @function formatChips
	 * @description Convert skake value to list of index of chip set
	 * @instance
	 * @private
	 * @return {array} Index array of the chip set
	 */
	function formatChips(stakeUnits){
		if(!config){
			throw new Error("Currency: currency config is required");
		}

		var i = chipSet.length, chips = [];

		//convert stakeUnits to multiples of the smallest chip
		stakeUnits = Math.round(stakeUnits * denomamount / minChip);
		while(--i >= 0 && stakeUnits > 0){
			while(stakeUnits - chipSet[i] >= 0){
				chips.push(i);
				stakeUnits -= chipSet[i];
			}
		}

		return chips;
	}

	/**
	 * @function chipStackToStakeUnits
	 * @description Iterate all the chips in chip stake and convert sum of the chip values to stake unit values
 	 * @instance
	 * @param chipStake {array} - Array of chip values
	 * @return {float} stake units
	 */
	function chipStackToStakeUnits(chipStake){	
		var v = 0, i = chipStake.length - 1;

		while(i >= 0){
			v += chipSet[chipStake[i]] * minChip;
			i--;
		}

		return toStakeUnits(v);
	}

	/**
	 * @function chipStackMapToCurrency
	 * @description Convert chip stake to currency stake
 	 * @instance
	 * @param chipStake {array} - Array of chip values
	 * @return {array} array with currency
	 */
	function  chipStackMapToCurrency(chipStake){
		return chipStake.map(function(i){
			return chipSet[i] * minChip;
		});
	}

	/**
	 * @function getPlayChips
	 * @description Get an array of chip indexes contains at most of the specificed number (numberOfChips) that no chip value exceeding maxbet
	 * @instance
	 * @param numberOfChips {int} Maximum number of chips to show
	 * @param maxbet {number} Value of maximum bet in multiples of the denom amount
	 * @return {array} Array of chip indexes
	 */
	function getPlayChips(numberOfChips, maxbet){
		//convert _minBet from stake units to multiples of the smallest chip value
		var minBetStakeUnits = Math.round(denomamount / minChip), 
    		chips = [],
		    i;

		//if maxbet is not set   , or is 0, don't restrict 
		maxbet = Math.round(maxbet * denomamount / minChip) || Infinity;

		//find the first chip that is greater than or equals to minbet
		for(i = 0; i < chipSet.length; i++){
			if(chipSet[i] >= minBetStakeUnits && chipSet[i] <= maxbet && 0 < numberOfChips--){
				chips.push(i);
			}
		}

		// if no chip what >= above, this returns an empty array
		// if there are less than numberOfChips after chip i, then returns the remainder
		return chips;
	}

	/**
	 * @function chipToStakeUnits
	 * @description Convert from chip index to stake units value
	 * @param chipIndex {int}
	 * @return {int}
	 */
	function chipToStakeUnits(chipIndex){
		return toStakeUnits(chipSet[chipIndex] * minChip);
	} 

	/**
	 * @function reset
	 * @description Reset currency object with new configuraiton or just clean it up
	 * @instance
	 * @return undefined
	 */
	function reset(newConfig){
		if(newConfig){
			init(newConfig);
		}else{
			config = undefined;

			currencyCode = undefined;
			language = undefined;
			minorSymbol = undefined;
			majorPrefix = undefined;
			majorSuffix = undefined;
			minorPrefix = undefined;
			minorSuffix = undefined;
			decimalSeparator = undefined;
			thousandsSeparator = undefined;
			decimalPrecision = undefined;
			minorCurrencyLock = undefined;
			denomamount = undefined;
			chipSetCode = undefined;
			chipSet = undefined;
			minChip = undefined;
		}
	}

	function updateDenom(denom){
		// default of denominaiton of 1
		denomamount = denom ? denom : 1;
	}

	/**
	 * @function toCurrency
	 * @description From stake to currency value
	 * @param stakeUnits {number} - the stake currency's units
	 * @returns {string} the currency formatted into the proper units
	 */
	function toCurrency(stakeUnits){
		if(!config){
			throw new Error("Currency: currency config is required");
		}

		return (stakeUnits * denomamount).toFixed(decimalPrecision);
	}

	export default Object.freeze({
		init: init,
		format: format,
		formatChips: formatChips,
		toCurrency: toCurrency,
		formatFloat : formatFloat,
		formatShort: formatShort,
		formatLong: formatLong,
		chipStackToStakeUnits: chipStackToStakeUnits,
		chipStackMapToCurrency: chipStackMapToCurrency,
		toStakeUnits : toStakeUnits,
		getPlayChips: getPlayChips,
		chipToStakeUnits: chipToStakeUnits,
		getConfig: function(){
			return config;
		},
		getCurrencyCode: function(){
			return currencyCode;
		},
		getLanguage: function(){
			return language;
		},
		reset: reset,
		updateDenom: updateDenom
	});

//});